module.exports = __webpack_public_path__ + "img/handshake.0ee6efe1.png";